import { z } from "zod";
/** Matches or returns a record's title rather than one of its fields. */
export const CHANNEL_FIELD_LOOKUP_TITLE_KEY = "__title";
/**
 * Matches a record by its id, as a Record link field holds it: a lookup can follow a link to the record it names.
 * Only a key: it is never a value to show, since the link itself shows the record.
 */
export const CHANNEL_FIELD_LOOKUP_ID_KEY = "__id";
const lookupFieldKeySchema = z.string().trim().min(1).max(200);
/**
 * A field that takes its value from another data set, as `config.lookup`: each record's `matchFieldKey` value is
 * found among the `objectTypeId` data set's `keyFieldKey` values, and that record's `valueFieldKey` is this field's
 * value. It is worked out on every read, so a change to the other data set shows at once, and no one writes it. A
 * value with no match reads as blank. Records there that share a key but give different values, a blank counting as a
 * value, make the read fail, naming the key, rather than choose one or hide the amounts. `__title` names a record's title,
 * and `__id`, as the key only, its id: a lookup matching a Record link field on `__id` follows the link.
 */
export const channelFieldLookupSchema = z.object({
    objectTypeId: z.string().trim().min(1).max(200),
    matchFieldKey: lookupFieldKeySchema,
    keyFieldKey: lookupFieldKeySchema,
    valueFieldKey: lookupFieldKeySchema,
}).strict();
/** The field's lookup, or null for a field people or a source fill. A malformed lookup is refused, not ignored. */
export function channelFieldLookup(config) {
    if (!config || config.lookup === undefined || config.lookup === null)
        return null;
    return channelFieldLookupSchema.parse(config.lookup);
}
